import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/projects/research-management-system/client-page.tsx");
